export default {
  button: "table-panel-actions-button",
  link: "table-panel-actions-link",
  list: "table-panel-actions-list",
};
